import React, { useState } from 'react';
import qs from 'querystring';
import axios from 'axios';

function DeleteApplication({ applicationData }) {
  const aid = applicationData.aid ?? '';
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDeleteApplication = () => {
    setLoading(true);
    axios
      .post(
        window.wlPipConfig.ajaxUrl,
        qs.stringify({ action: 'wl_fip_delete_application', aid: aid })
      )
      .then(({ data: { data } }) => {
        setTimeout(() => location.reload(), 1000);
      })
      .catch((error) => {
        console.log(error);

        setTimeout(() => setLoading(false), 250);
      });
  };

  return (
    <>
      <button
        className={`btn btn--lg module-hover-root ${
          showDeleteModal ? 'btn--white' : 'btn--pip-red'
        }`}
        type="button"
        onClick={() => setShowDeleteModal(!showDeleteModal)}
      >
        <span className="btn__content">
          <span className="btn__text">
            {showDeleteModal ? 'Nevermind' : 'Delete Application'}
          </span>
        </span>
      </button>
      {showDeleteModal && (
        <div className="u--margin-top-30">
          <p>
            <b>
              Are you sure you want to delete this application? This cannot be
              undone.
            </b>
          </p>
          <button
            className={`btn btn--lg ${
              loading && 'btn--loading '
            } module-hover-root btn--pip-red`}
            type="button"
            onClick={() => handleDeleteApplication()}
          >
            <span className="btn__content">
              <span className="btn__text">Yes, Delete Application</span>
            </span>
          </button>
        </div>
      )}
    </>
  );
}

export default DeleteApplication;
